import i18n, { TFunction } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import overrideTranslations from "common/utils/overrideTranslation";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/pt-br";

// import translationEN from './translations/en.json';
import translationFR from "./translations/fr.json";
import translationEN from "./translations/en.json";
import translationDE from "./translations/de.json";
import translationES from "./translations/es.json";
import translationPT from "./translations/pt-BR.json";

dayjs.extend(utc);

export const defaultNS = "translation";
export const FALLBACK_LANGUAGE = "fr";
// Store original unmodified resources for patching
export const originalResources = JSON.parse(
  JSON.stringify({
    fr: {
      translation: translationFR,
    },
    en: {
      translation: translationEN,
    },
    de: {
      translation: translationDE,
    },
    es: {
      translation: translationES,
    },
    "pt-BR": {
      translation: translationPT,
    },
  })
);

// Export for use in the application
export const resources = JSON.parse(JSON.stringify(originalResources));

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}
// i18n.on("initialized", (options) => {
//   console.log("Language detected:", i18n.language);
//   localStorage.setItem("browserLanguage", i18n.language);
//   console.log("Saved :", localStorage.getItem("browserLanguage"));
// });
// Store custom translations to reapply when language changes
let storedCustomTranslations: Record<string, Record<string, string>> | null =
  null;

export function setCustomTranslations(
  translations: Record<string, Record<string, string>>
) {
  storedCustomTranslations = translations;
}

export function getCustomTranslations() {
  return storedCustomTranslations;
}

i18n.on("languageChanged", (lng) => {
  // Reapply custom translations when language changes
  if (storedCustomTranslations) {
    overrideTranslations(storedCustomTranslations);
  }
});

i18n
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    debug: true,
    returnNull: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    ns: ["translation"],
    defaultNS,
    resources,
    detection: {
      order: [
        "querystring",
        "localStorage",
        "navigator",
        "hash",
        "cookie",
        "sessionStorage",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
  });

export default i18n;

export type I18nKey = Parameters<TFunction>[0];
